import axios from 'axios';
import dayjs from 'dayjs';
import { Dialog, Toast } from 'vant';

import store from '@this/store';
import AuthPopup from '@blocks/auth/AuthPopup';
import { getAuthJumpURL } from '@blocks/auth/service';

import { isPC, isAlipay } from '@/utils/browser';

let loadingCount = 0;

const service = axios.create({
  baseURL: process.env.VUE_APP_H5_BASE,
  timeout: 10 * 10000,
});

service.interceptors.request.use(
  (config) => {
    // 活动结束
    const { endTime } = process.env.VUE_APP_H5_PRO;
    const startTimeDayjs = dayjs();
    const endTimeDayjs = dayjs(endTime);
    if (startTimeDayjs.isAfter(endTimeDayjs)) {
      const message = '活动已结束';
      Dialog({
        title: '提示',
        message,
        showConfirmButton: false,
      });
      return Promise.reject({ message });
    }
    // 使用loading
    handleUseLoading(config, 'add');
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    return new Promise((resolve, reject) => {
      const { config } = response;
      // 使用loading
      handleUseLoading(config, 'subtract');
      // 自动判断未授权/过期
      const res = response.data;
      const { code, msg } = res;
      if (handleUseCode(config, code)) {
        if (code === 4300) {
          // 使用auth
          handleUseAuth({ config, result: res, resolve, reject });
        } else {
          // 使用toast
          handleUseToast(config, msg);
          reject(res);
        }
      } else {
        resolve(res);
      }
    });
  },
  (error) => {
    const { config, message } = error;
    if (config) {
      // 使用loading
      handleUseLoading(config, 'subtract');
      // 使用toast
      handleUseToast(config, message);
    }
    return Promise.reject(error);
  }
);

function handleUseLoading(config, type) {
  const { useLoading = false } = config;
  if (!useLoading) {
    return;
  }
  // 加减
  switch (type) {
    case 'add':
      loadingCount++;
      break;
    case 'subtract':
      loadingCount--;
      break;
    default:
      throw '操作不存在';
  }
  // 显示隐藏
  if (loadingCount > 0) {
    Toast.loading({
      message: 'Loading...',
      duration: 0,
      forbidClick: true,
    });
  } else {
    Toast.clear();
  }
}

function handleUseCode(config, code) {
  // 使用自定义code
  const { useCode = 0 } = config;
  return code && code !== useCode;
}

function handleUseAuth({ config, result, resolve, reject }) {
  // 使用auth
  const { useAuth = true } = config;
  if (!useAuth) {
    return reject(result);
  }
  // 判断pc端
  if (isPC) {
    AuthPopup(window.parent.location.href);
    return reject({});
  }
  // 监听回来
  if (isAlipay) {
    const handleResume = () => {
      ap.offResume(handleResume);
      // 授权成功后操作
      const res = JSON.parse(localStorage.getItem('authSuccess')) || {};
      localStorage.removeItem('authSuccess');
      if (res.success === true) {
        store
          .dispatch('user/authSuccess')
          .then(() => {
            // 继续授权成功前接口
            service(config)
              .then((res) => {
                resolve(res);
              })
              .catch((error) => {
                reject(error);
              });
          })
          .catch((error) => {
            reject(error);
          });
      } else {
        reject({});
      }
    };
    ap.onResume(handleResume);
  }
  // 跳转
  if (isAlipay) {
    const callback = `${window.location.origin}/dist/_static/close.html`;
    const jumpURL = getAuthJumpURL(callback);
    ap.pushWindow(jumpURL);
  } else {
    const callback = window.parent.location.href;
    const jumpURL = getAuthJumpURL(callback);
    window.parent.location.href = jumpURL;
  }
}

function handleUseToast(config, message) {
  const { useToast = true } = config;
  if (!useToast) {
    return;
  }
  // 提示
  Toast(message || 'Error');
}

export default service;
